import { encodeBase64, saveAs } from "@progress/kendo-file-saver";


export const exportToExcel = (data: any,fileName: string)=> {
    const dataURI = "data:text/plain;base64," + encodeBase64(data.join('\n'));
    saveAs(dataURI, fileName);
}